export default "<app-company-form (onsubmit)=\"save($event)\" [company]=\"company\"></app-company-form>";